export default __webpack_public_path__ + "static/media/Formations-pratique-quotidien.d137f404.jpg";